import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentGenerationApiService extends ApiService {
  //private shouldFailGenerateClauseListOnce = true;

  generateClauseList$(items: GenerateClauseListPayload): Observable<GenerateClauseListResponse> {
    // if (this.shouldFailGenerateClauseListOnce) {
    //   this.shouldFailGenerateClauseListOnce = false;

    //   return timer(1000).pipe(
    //     mergeMap(
    //       (): Observable<GenerateClauseListResponse> =>
    //         throwError(
    //           () =>
    //             new HttpErrorResponse({
    //               error: {
    //                 items,
    //                 message: 'Simulated generate clause list failure.',
    //               },
    //               status: 500,
    //               statusText: 'Internal Server Error',
    //             }),
    //         ),
    //     ),
    //   );
    // }

    return this.post(`/documentGeneration/generate-clause-list`, items);
  }

  generateDocument$(clauses: GenerateClauseListResponse): Observable<GenerateDocumentResponse> {
    return this.post(`/documentGeneration/generate-document`, clauses);
  }

  getdocumentGenerationStatus$(
    documentGenerationTrackingId: string,
  ): Observable<GetDocumentGenerationStatusResponse> {
    return this.get(
      `/documentGeneration/document-generation-status/${documentGenerationTrackingId}`,
    );
  }
}

export interface GenerateClauseListPayload {
  documentTypeId: number;
  languageId: number;
  positionId: number;
  parties?: number[]; // optional, will be used in future
}

export interface GenerateClauseListResponse {
  documentGenerationTrackingId: string;
  contractType: string;
  documentStructure: DocumentStructureItem[];
}

export interface DocumentStructureItem {
  associatedRuleIds: number[];
  content: string[];
  isSuggested: boolean;
  order: number;
  subclauses: SubClauseItem[];
  title: string;
}

export interface SubClauseItem {
  associatedRuleIds: number[];
  content: string[];
  isSuggested: boolean;
  order: number;
  title: string;
}

export interface GenerateDocumentResponse {
  documentGenerationTrackingId: string;
  documentName: string;
}

export interface GetDocumentGenerationStatusResponse {
  documentGenerationTrackingId: string;
  documentUniqueId: string;
  status: DocumentGenerationStatus;
}

export enum DocumentGenerationStatus {
  InProgress = 0,
  Completed = 1,
  Failure = 2,
}

export const apiDocumentGenerationProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiDocumentGeneration.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiDocumentGeneration.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiDocumentGeneration.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiDocumentGeneration.scopes.write],
  },
];
